import React, { useState } from "react";
import { Box, Button, Grid, Modal, Paper, Typography } from "@mui/material";
import DoneOutlineIcon from '@mui/icons-material/DoneOutline';
import { LoadingButton } from "@mui/lab";
import { useNavigate } from "react-router-dom";
import { globals } from "../../data/Globals";

export const ModalConfirmacion = ({open, onClose, id, toneladas, observ})=>{
    const navigate = useNavigate();
    const [loadingRecogido, setLoadingRecogido] = useState(false)

    const handleRecogido = () => {
        async function insertRecogida(){
            const response = await fetch(`https://ekogest-api.azurewebsites.net/api/BBDD_Api`,{
                method:'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': process.env.REACT_APP_API_KEY,
                },
                body: JSON.stringify({
                    'page':'Recogido',
                    'token':globals.user.TOKEN,
                    'id': id,
                    'toneladas': Math.round(parseFloat(toneladas.replace(",",".")) * 100)/ 100,
                    'observaciones':observ
                })
            })

            if(response.status !== 200){
                const message = await response.json();
                console.log(message)
                return
            }          

            setLoadingRecogido(false)
            navigate(0)
        }

        insertRecogida()
    }

    return(
        <Modal open={open} onClose={onClose} sx={{zIndex:"1500"}}>
            <Box
            sx={{
            position: 'absolute',
            width: "100vw",
            height: "100vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            pointerEvents: "none"
            }}>
                <Paper sx={{width: "40vw", minWidth: "600px", display: "flex", alignItems: "center", pointerEvents:"auto"}}>
                    <Grid container display="flex" justifyContent="space-evenly" rowGap={3} mt={5} mb={5}>
                        <Grid item xs={10}>
                            <Typography variant="h5" align="center"><b>¿Confirmas que la recogida ha finalizado?</b></Typography>
                        </Grid>
                        <Grid item xs={3} mt={7}>
                            <Button variant="contained" size="large" endIcon={<DoneOutlineIcon/>} onClick={handleRecogido}>
                                <Typography variant="h5"><b>Sí</b></Typography>
                            </Button>
                        </Grid>
                        <Grid item xs={2} display="flex" justifyContent="end" mt={7}>
                            <Button size="large" onClick={onClose}>
                                <Typography variant="h5">No</Typography>
                            </Button>
                        </Grid>
                    </Grid>
                </Paper>
            </Box>
        </Modal>
    )
}